<div class="dark-mode" *ngrxLet="isDarkMode$ as isDarkMode">
    <div class="dark-mode-toggle" (click)="toggleDarkMode()" [class.dark-mode-active]="isDarkMode">
        <dtm-ui-icon class="dark-mode-toggle-icon" name="sun-fill" *ngIf="!isDarkMode"></dtm-ui-icon>
        <dtm-ui-icon class="dark-mode-toggle-icon" name="moon-fill" *ngIf="isDarkMode"></dtm-ui-icon>
    </div>
    <mat-slide-toggle [ngModel]="isDarkMode" (change)="toggleDarkMode()"> </mat-slide-toggle>
</div>
